let globalErrorCounter = 0;

// --- ÜBERSETZUNGEN ---
const defaultTranslations = {
    required: 'Dieses Feld ist erforderlich.',
    email_invalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    url_invalid: 'Bitte geben Sie eine gültige URL ein.',
    number_min: 'Der Wert ist zu klein.',
    number_max: 'Der Wert ist zu groß.',
    pattern_invalid: 'Das Format der Eingabe ist ungültig.',
    generic_invalid: 'Die Eingabe ist ungültig.'
};

const i18n = (typeof WCO_Form_Translations !== 'undefined')
    ? { ...defaultTranslations, ...WCO_Form_Translations }
    : defaultTranslations;


function initFormErrorOptimization() {
    const forms = document.querySelectorAll('.elementor-form');

    if (!forms.length) {
        return;
    }

    forms.forEach(form => {
        // Mutation Observer
        const observerConfig = { attributes: true, childList: true, subtree: true };
        const observer = new MutationObserver((mutations) => {
            let errorFound = false;
            for (const mutation of mutations) {
                if (mutation.type === 'attributes' && mutation.target.classList && mutation.target.classList.contains('elementor-error')) {
                    errorFound = true; break;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1 && (node.classList.contains('elementor-message') || node.querySelector('.elementor-message'))) {
                            errorFound = true;
                        }
                    });
                    if (errorFound) break;
                }
            }
            if (errorFound) {
                requestAnimationFrame(() => { applyAccessibilityFixes(form); });
            }
        });
        observer.observe(form, observerConfig);

        form.addEventListener('submit', (event) => {
            const hasRadioErrors = validateRadioFields(form);
            const hasStandardErrors = validateStandardFields(form);

            if (hasRadioErrors || hasStandardErrors) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        }, true);
    });
}

function validateRadioFields(form) {
    const radioGroups = form.querySelectorAll('.elementor-field-type-radio.elementor-field-required');
    let errorFound = false;

    radioGroups.forEach(group => {
        const inputs = group.querySelectorAll('input[type="radio"]');
        const isChecked = Array.from(inputs).some(input => input.checked);

        if (!isChecked) {
            errorFound = true;
            showErrorOnWrapper(group, i18n.required);
        } else {
            removeErrorOnWrapper(group);
            inputs.forEach(input => input.setAttribute('aria-invalid', 'false'));
        }
    });

    return errorFound;
}

function validateStandardFields(form) {
    const inputs = form.querySelectorAll('input:not([type="radio"]):not([type="hidden"]):not([type="submit"]):not([type="button"]), textarea, select');
    let errorFound = false;

    inputs.forEach(input => {
        const wrapper = input.closest('.elementor-field-group');

        if (wrapper) {
            if (!input.checkValidity()) {
                errorFound = true;
                const message = getSpecificErrorMessage(input);
                showErrorOnWrapper(wrapper, message);
            } else {
                removeErrorOnWrapper(wrapper);
                input.setAttribute('aria-invalid', 'false');
            }
        }
    });

    return errorFound;
}

function getSpecificErrorMessage(input) {
    const validity = input.validity;
    if (validity.valueMissing) return i18n.required;
    if (validity.typeMismatch) {
        if (input.type === 'email') return i18n.email_invalid;
        if (input.type === 'url') return i18n.url_invalid;
    }
    if (validity.patternMismatch) return input.title || i18n.pattern_invalid;
    if (validity.rangeUnderflow) return i18n.number_min;
    if (validity.rangeOverflow) return i18n.number_max;
    return input.validationMessage || i18n.generic_invalid;
}

/**
 * Fügt Fehlerklasse und Nachricht hinzu
 */
function showErrorOnWrapper(wrapper, messageText) {
    const subGroup = wrapper.querySelector('.elementor-field-subgroup');
    let targetContainer = wrapper;

    if (subGroup) {
        if (wrapper.classList.contains('elementor-field-type-radio')) {
            targetContainer = subGroup;
        } else {
            const optionSpan = subGroup.querySelector('.elementor-field-option');
            if(optionSpan) targetContainer = optionSpan;
        }
    }

    wrapper.classList.add('elementor-error');

    if (targetContainer !== wrapper) {
        targetContainer.classList.add('elementor-error');
    }

    let existingError = targetContainer.querySelector('.elementor-message.elementor-help-inline');

    if (!existingError) {
        const errorSpan = document.createElement('span');
        errorSpan.className = 'elementor-message elementor-message-danger elementor-help-inline elementor-form-help-inline';
        errorSpan.setAttribute('role', 'alert');
        errorSpan.innerText = messageText;
        targetContainer.appendChild(errorSpan);
    } else {
        if (existingError.innerText !== messageText) {
            existingError.innerText = messageText;
        }
    }
}

/**
 * Entfernt Fehler
 */
function removeErrorOnWrapper(wrapper) {
    wrapper.classList.remove('elementor-error');

    let msgs = wrapper.querySelectorAll(':scope > .elementor-message.elementor-help-inline');
    msgs.forEach(m => m.remove());

    const subGroup = wrapper.querySelector('.elementor-field-subgroup');
    if (subGroup) {
        subGroup.classList.remove('elementor-error');
        let subGroupMsgs = subGroup.querySelectorAll(':scope > .elementor-message.elementor-help-inline');
        subGroupMsgs.forEach(m => m.remove());
    }

    const subOpts = wrapper.querySelectorAll('.elementor-field-option');
    subOpts.forEach(opt => {
        opt.classList.remove('elementor-error');
        let subMsgs = opt.querySelectorAll('.elementor-message.elementor-help-inline');
        subMsgs.forEach(m => m.remove());
    });
}

function applyAccessibilityFixes(form) {
    const errorMessages = form.querySelectorAll('.elementor-message.elementor-message-danger.elementor-help-inline');

    if (!errorMessages.length) {
        return;
    }

    let firstErrorInput = null;
    let changesMade = false;

    errorMessages.forEach(errorMessage => {
        const parentFieldGroup = errorMessage.closest('.elementor-field-group');

        if (!parentFieldGroup) return;

        const input = parentFieldGroup.querySelector('input:not([type="hidden"]):not([type="submit"]):not([type="button"]), textarea, select');

        if (input) {
            if (!errorMessage.id) {
                globalErrorCounter++;
                errorMessage.id = 'e-form-error-' + globalErrorCounter;
                changesMade = true;
            }
            const errorId = errorMessage.id;

            const isRadio = input.type === 'radio';
            const targets = isRadio ? parentFieldGroup.querySelectorAll('input[type="radio"]') : [input];

            targets.forEach(targetInput => {
                const currentDescribedBy = targetInput.getAttribute('aria-describedby') || '';
                if (!currentDescribedBy.includes(errorId)) {
                    const newDescribedBy = currentDescribedBy ? `${currentDescribedBy} ${errorId}` : errorId;
                    targetInput.setAttribute('aria-describedby', newDescribedBy.trim());
                    changesMade = true;
                }
                if (targetInput.getAttribute('aria-invalid') !== 'true') {
                    targetInput.setAttribute('aria-invalid', 'true');
                    changesMade = true;
                }
            });

            if (!firstErrorInput) {
                firstErrorInput = input;
            }
        }
    });

    if (firstErrorInput && changesMade) {
        setTimeout(() => {
            if (document.activeElement !== firstErrorInput) {
                firstErrorInput.focus();
            }
        }, 50);
    }
}

export { initFormErrorOptimization };